import { ref, onMounted, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {getUserData} from '@/auth/utils'

export default function useMessagesList(){

    const toast = useToast()

    const refMessageListTable = ref(null)

    const tableColumns = [
        {key:'name', sortable:true},
        {key:'email', sortable:true},
        {key:'message', sortable:true},
        {key:'remark', sortable:true},
        {key:'actions'}
    ]

    const perPage = ref(10)
    const totalMessages = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refMessageListTable.value ? refMessageListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1: 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalMessages.value,
        }
    })

    const showMessage = (title,text,icon, variant) =>{
        toast({
            component: ToastificationContent,
            props: {
              title,
              text,
              icon,
              variant
            },
        })
    }

    const refetchData = () =>{
        refMessageListTable.value.refresh()
    }

    const getMessageImage = (image) =>  process.env.VUE_APP_IMAGE_URL+image

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchMessages = (ctx, callback) => {

        store.dispatch('bar-message/fetchMessages', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            store_id: getUserData().store_id,
        })
        .then(response => {
            //console.log(response.data)
            const { messages, total} = response.data
            callback(messages)
            totalMessages.value = total
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                  title: 'Error fetching messages list',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
            })
        })
    }

    return {
        fetchMessages,
        tableColumns,
        perPage,
        currentPage,
        totalMessages,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refetchData,
        refMessageListTable,
        getMessageImage,
        showMessage,
    }

}